import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
export function NotFoundPage() {
  return <div className="text-center py-24" data-id="element-545">
      <p className="text-6xl font-serif font-bold text-navy-200 mb-2" data-id="element-546">404</p>
      <h1 className="text-2xl font-serif font-bold text-navy-900 mb-2" data-id="element-547">
        Page not found
      </h1>
      <p className="text-navy-500 mb-6" data-id="element-548">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-colors" data-id="element-549">
        <Home className="w-4 h-4" data-id="element-550" /> Back to Home
      </Link>
    </div>;
}